/* Fairfume bundel builder */
(function(){
  document.querySelectorAll('[data-bundle-builder]').forEach(function(root){
    var cfg={};try{cfg=JSON.parse(root.querySelector('[data-bb-config]').textContent);}catch(e){}
    var cards=[].slice.call(root.querySelectorAll('[data-bb-card]'));
    var packs=[].slice.call(root.querySelectorAll('input[name="bb-pack"]'));
    var picks=[]; // variant-id's in volgorde van kiezen
    var need=3,free=1,label='';

    function money(c){
      var fmt=cfg.moneyFormat||'€{{amount_with_comma_separator}}';
      function d(n,p,t,dc){n=(n/100).toFixed(p);var s=n.split('.');return s[0].replace(/\B(?=(\d{3})+(?!\d))/g,t)+(s[1]?dc+s[1]:'');}
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
        if(k==='amount')return d(c,2,',','.');
        if(k==='amount_no_decimals')return d(c,0,',','.');
        if(k==='amount_no_decimals_with_comma_separator')return d(c,0,'.',',');
        return d(c,2,'.',',');
      });
    }
    function card(id){return cards.find(function(c){return c.dataset.id===String(id);});}
    function setAll(sel,val){root.querySelectorAll(sel).forEach(function(e){e.textContent=val;});}

    function readPack(){
      var p=packs.find(function(x){return x.checked;})||packs[0];
      if(!p)return;
      need=+p.dataset.qty||3;free=+p.dataset.free||0;label=p.dataset.label||'';
      if(picks.length>need)picks=picks.slice(0,need);
    }

    function render(){
      var n=picks.length;
      setAll('[data-bb-need]',need);setAll('[data-bb-count]',n);
      // aantallen per kaart
      cards.forEach(function(c){
        var q=picks.filter(function(id){return id===c.dataset.id;}).length;
        var b=c.querySelector('[data-bb-qty]');b.textContent=q;b.hidden=q===0;
        c.querySelector('[data-bb-minus]').hidden=q===0;
        c.classList.toggle('is-picked',q>0);
        c.querySelector('[data-bb-plus]').disabled=n>=need;
      });
      // vakjes in het overzicht
      var slots=root.querySelector('[data-bb-slots]');var html='';
      for(var i=0;i<need;i++){
        var id=picks[i];
        if(id){var c=card(id);html+='<button type="button" class="bb-slot is-full" data-bb-remove="'+i+'" title="Verwijder '+c.dataset.title+'">'+(c.dataset.img?'<img src="'+c.dataset.img+'" alt="">':'')+'<span>×</span></button>';}
        else html+='<span class="bb-slot"></span>';
      }
      slots.innerHTML=html;
      // bedragen: de goedkoopste flesjes zijn gratis
      var prices=picks.map(function(id){return +card(id).dataset.price;});
      var sub=prices.reduce(function(a,b){return a+b;},0);
      var disc=0;
      if(n===need&&free>0){disc=prices.slice().sort(function(a,b){return a-b;}).slice(0,free).reduce(function(a,b){return a+b;},0);}
      setAll('[data-bb-sub]',money(sub));
      setAll('[data-bb-disc]',disc>0?'−'+money(disc):'–');
      setAll('[data-bb-total]',money(sub-disc));
      root.querySelector('[data-bb-bar]').style.width=(need?Math.round(n*100/need):0)+'%';
      var hint=root.querySelector('[data-bb-hint]');
      hint.textContent=n===0?'Kies '+need+' parfums':(n<need?'Nog '+(need-n)+' te gaan':(free>0?'Je bundel is compleet, '+free+(free===1?' flesje is':' flesjes zijn')+' gratis':'Je bundel is compleet'));
      root.querySelectorAll('[data-bb-add]').forEach(function(b){b.disabled=n!==need;});
      root.querySelector('[data-bb-mobilebar]').classList.toggle('show',n>0);
    }

    root.addEventListener('click',function(e){
      var t=e.target;
      var f=t.closest('[data-bb-filter]');
      if(f){
        root.querySelectorAll('[data-bb-filter]').forEach(function(x){x.classList.toggle('is-on',x===f);});
        var v=f.dataset.bbFilter;cards.forEach(function(c){c.hidden=!!v&&c.dataset.type!==v;});
        return;
      }
      var plus=t.closest('[data-bb-plus]');
      if(plus){var c=plus.closest('[data-bb-card]');if(picks.length<need){picks.push(c.dataset.id);render();}return;}
      var minus=t.closest('[data-bb-minus]');
      if(minus){var c2=minus.closest('[data-bb-card]');var i=picks.lastIndexOf(c2.dataset.id);if(i>-1){picks.splice(i,1);render();}return;}
      var rm=t.closest('[data-bb-remove]');
      if(rm){picks.splice(+rm.dataset.bbRemove,1);render();return;}
      var add=t.closest('[data-bb-add]');
      if(add&&picks.length===need){
        var counts={};picks.forEach(function(id){counts[id]=(counts[id]||0)+1;});
        var items=Object.keys(counts).map(function(id){
          var it={id:+id,quantity:counts[id]};
          if(cfg.property)it.properties={};
          if(cfg.property)it.properties[cfg.property]=label;
          return it;
        });
        root.querySelectorAll('[data-bb-add]').forEach(function(b){b.disabled=true;});
        var done=function(){picks=[];render();};
        if(window.TTCart&&TTCart.add){TTCart.add(items).then(done).catch(function(){render();});}
        else{
          fetch((window.theme&&theme.cartAddUrl||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
            .then(function(){window.location.href=(window.theme&&theme.cartUrl)||'/cart';});
        }
      }
    });
    packs.forEach(function(p){p.addEventListener('change',function(){readPack();render();});});
    readPack();render();
  });
})();
